module.exports = __webpack_public_path__ + "static/media/scroll-down.22595c46.svg";